import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { DataTableProps } from "./DataTable.types";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    position: "relative",
  },
  paper: {
    width: "100%",
    overflowX: "auto",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: "100%",
    userSelect: "text",
    cursor: "text",
    "& thead": {
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
      background: theme.palette.grey[100],
    },
  },
  circle: {
    color: theme.palette.grey[500],
    "&:hover": {
      color: theme.palette.primary.main,
      borderRadius: "50%",
      background: "#F4F6FB",
      cursor: "pointer",
    },
  },
  checkboxCell: {
    width: 18,
    paddingRight: "0 !important",
  },
  actionsCell: (props: DataTableProps<any>) => ({
    width: `calc(40px + ${theme.spacing(props.sidePadding || 0)})`,
    minWidth: `calc(40px + ${theme.spacing(props.sidePadding || 0)})`,
  }),
}));
